import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import CustomStore from 'devextreme/data/custom_store';

import { BehaviorSubject, catchError, Observable } from 'rxjs';
import { MessageResponse } from 'src/app/Interfaces/MessageResponse';
import { environment } from 'src/environments/environment';
import { HandleError, HttpErrorHandler } from '../http-error-handler.service';
import { NotifyService } from './notify.service';
import { Employee } from 'src/app/Interfaces/hr/employee';

@Injectable({
  providedIn: 'root'
})
export class  EmployeeService {
  dataSource: any;
  private handleError: HandleError;
  public customDataSource: any;
  $EMPLOYEE_ID = new BehaviorSubject<number>(0);
  $Attachment_ID = new BehaviorSubject<number>(0);
  $Status_ID = new BehaviorSubject<number>(0);
  $ReFRESHGRID = new BehaviorSubject<boolean>(false);
  customDataSourceEmployee: CustomStore;
  refresh: boolean;
  constructor(private http: HttpClient, public httpErrorHandler: HttpErrorHandler, public NotifyService: NotifyService,
    public translatee: TranslateService) {
    this.handleError = httpErrorHandler.createHandleError('ObjectService');

    const isNotEmpty = (value: any) => value !== undefined && value !== null && value !== '';

    this.customDataSourceEmployee = new CustomStore({
      key: 'id',
      load: (loadOptions: any) => {
        let params = new HttpParams();
        [
          'requireTotalCount',
          // 'skip',
          // 'take',
        ].forEach(function (i) {
          if (i in loadOptions && isNotEmpty(loadOptions[i])) {
            params = params.append(i, JSON.stringify(loadOptions[i]));
          }

        });
        return this.http.get(`${environment.apiRoot}/api/Employee/all`, { params: params })
          .toPromise()
          .then((response: any) => {
            return {
              data: response.data,
              totalCount: response?.countRecord,
            };

          })

          .catch(() => { throw 'Data loading error' });
      },
      remove: (key) => {
        return this.http.delete(`${environment.apiRoot}/api/Employee/Delete?id=` + encodeURIComponent(key)).toPromise().then((message: MessageResponse) => { })
      }

    })
  }

  byKey(key: any) {
    return this.http.get(`${environment.apiRoot}/api/Employee/GetById/${key}`)
  }
  getaccountingdata(data: any) {
    return this.http.post(`${environment.apiRoot}/api/Employee/RefreshInsuranceAndTaxtesEmployee`, data).pipe(catchError(
      this.httpErrorHandler.handleError('get'))).toPromise().then((res: any) => {
        return res
      })
  }
  updateemployee(data: any) {
    return this.http.put(`${environment.apiRoot}/api/Employee/Update`, data)
  }
  addemployee(data: any) {
    return this.http.post(`${environment.apiRoot}/api/Employee/Add`, data)
  }
 
  getallemployee() {
    return this.http.get(`${environment.apiRoot}/api/Employee/all`)
  }
  getallemployeeinformation(): Observable<Employee[]> {
    return this.http.get<Employee[]>(`${environment.apiRoot}/api/Employee/GetDropDown/EmployeeInformation`);
  }
  EmployeeSystems(data: any) {
    return this.http.get(`${environment.apiRoot}/api/EmployeeSystems/GetById/${data}`).pipe(catchError(
      this.httpErrorHandler.handleError('add'))).toPromise().then((res: any) => {
        return res
      })
  }
   getemployeecount(){

      return this.http.get(`${environment.apiRoot}/api/Employee/EmployeeCount`)
   }
  EditEmployeeSystems(data: any) {
    return this.http.put(`${environment.apiRoot}/api/EmployeeSystems/Update`, data)
  }

  updatedropdown(selectedid: any = [], idkey: string, list: any = [], action: string) {
    list.forEach((element: any) => {
      if (element.id == selectedid[idkey]) {
        action == "remove" ? element.disabled = false : element.disabled = true
      }
    });
  }

  getmangementdropdown(api: string) {
    return this.http.get(`${environment.apiRoot}/api/${api}`)
  }
  getJobTitledropdown(api: string, id: number) {
    return this.http.get(`${environment.apiRoot}/api/${api}/${id}`)
  }

  //change Employee Work Status
  changeEmployeeWorkStatus (data:any) {
    return this.http.post(`${environment.apiRoot}/api/Employee/ChangeEmployeeWorkStatus`, data)
  }
 getEmployeesdropdown():Observable<any> {
    return this.http.get(`${environment.apiRoot}/api/Employee/GetDropDown`)
  }
 //EmployeeMessions 
 AddEmployeeMission (data:any) {
    return this.http.post(`${environment.apiRoot}/api/EmployeeMission/Add`, data)
  }
  GetAllEmployeeMission () {
    return this.http.get(`${environment.apiRoot}/api/EmployeeMission/all`)
  }
   GetEmployeeMissionTypes () {
    return this.http.get(`${environment.apiRoot}/api/EmployeeMission/GetDropDown`)
  }
   GetEmployeeMissionByid (id:number) {
    return this.http.get(`${environment.apiRoot}/api/EmployeeMission/GetById/${id}`)
  }
  updateEmployeeMission (data:any) {
    return this.http.put(`${environment.apiRoot}/api/EmployeeMission/Update`, data)
  }
 DeleteEmployeeMission(id: number) {
  return this.http.delete(`${environment.apiRoot}/api/EmployeeMission/Delete?id=${id}`);
}

previewBulkUpload(items: any[]) {
  return this.http.post(
    `${environment.apiRoot}/api/Employee/bulk-preview`,
    {
      items: items
    }
  );
}
saveBulkUpload(rows: any[]) {
  return this.http.post(
    `${environment.apiRoot}/api/Employee/bulk-save`,
    {
      rows: rows
    }
  );
}
getAllRequestsForReview(model:any){

    return this.http.get<any[]>(
        `${environment.apiRoot}/api/Employee/GetAllRequestsForReview`,
        {
            params:model
        });

}

getRequestTypes(){

    return this.http.get<any[]>(
        `${environment.apiRoot}/api/Employee/GetDropDown/GetRequestType`);

}

}




